import { Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'md-button',
  templateUrl: './md-button.component.html',
  styleUrls: ['./md-button.component.scss']
})
export class MdButtonComponent {
  @Input() color: "primary" | "primary-stroked" | "primary-text" | "primary-opacity" | "accent" | "accent-stroked" | "accent-text" | "accent-opacity" | "warn" | "warn-stroked" | "warn-text" | "warn-opacity";
  @Input() disabled = false;
  @Input() type = '';
  @Output() click = new EventEmitter();
  @HostBinding('class')
  get hostClass(): string {
    return this.disabled ? 'disabled' : 'enabled';
  }
  
}
